module.exports = __webpack_public_path__ + "img/avatar-1.c61d3426.png";